import { PilatesFive, PilatesFour, PilatesHome, PilatesOne, PilatesSix, PilatesThree, PilatesTwo } from "../assets/images/images";

const pilatesData = {
    heading: "The Best Software For Pilates Studio",
    subtitle:
        "EasyMembr provides a dedicated software solution tailored specifically for Pilates studios. It streamlines daily operations like class scheduling, client management, and payment handling, allowing you to concentrate on improving member experiences and expanding your studio.",
    trialText: "Get Started Now",
    demoText: "Book A Demo",
    imageSrc: PilatesHome,
    infoItems: ["No Card Required", "Cancel Anytime", "Affordable Pricing"],
    FeatureHead: "Features of Pilates Studio Management: Efficient Scheduling & Client Engagement",
    FeatureDesc: "Explore the powerful features designed to optimize your Pilates studio operations.",
    FeaturesDetails: [
        {
            id: 1,
            title: "Automated Class Scheduling and Booking",
            description: [
                "Easymembr simplifies scheduling for Pilates classes, helping staff and clients manage sessions effortlessly.",
                "Easily handle cancellations, rebookings, and waitlists—ensuring flexibility and satisfaction for your clients.",
                "Clients can book sessions via a web portal or mobile app anytime, promoting engagement and convenience.",
            ],
            image: PilatesOne
        },
        {
            id: 2,
            title: "Client Profile Management and Secure Data Storage",
            description: [
                "Store and access client preferences, session history, and goals for personalized service.",
                "Use insights to tailor communications and improve member retention.",
                "Ensure compliance and data protection with strong security protocols.",
            ],
            image: PilatesTwo
            // link: "Find Out More →",
        },
        {
            id: 3,
            title: "Flexible Payment Processing and Billing Automation",
            description: [
                "Integrate with multiple payment gateways for seamless credit card and online transactions.",
                "Automate invoicing, receipts, and recurring payments to reduce manual work.",
                "Support memberships and class packages, enhancing revenue flow and tracking.",
            ],
            image: PilatesThree
        },
        {
            id: 4,
            title: "Real-Time Reports and Business Intelligence",
            description: [
                "View key metrics like class attendance, revenue, and membership growth instantly.",
                "Customize reports to evaluate business performance and identify opportunities.",
                "Use data-driven insights to shape your studio strategy and improve services.",
            ],
            image: PilatesFour
        },
        {
            id: 5,
            title: "Mobile App for Clients and Staff Flexibility",
            description: [
                "Use our branded mobile app to book classes, make payments, and stay informed.",
                "Send real-time updates and reminders to boost client engagement.",
                "Empower staff to manage schedules and client interactions on the go.",
            ],
            image: PilatesSix
        },
        {
            id: 6,
            title: "Staff Scheduling and Payroll Management",
            description: [
                "Track staff hours, attendance, and session allocations efficiently.",
                "Automatically calculate payroll, including deductions and tax compliance.",
                "Monitor instructor performance through feedback and attendance data.",
            ],
            image: PilatesFive
        },
    ],
    HighlighCardDetails: [
        {
            id: 1,
            subtitle: "TOP RATED SOFTWARE",
            title: "Book a Demo Now!",
            description: [
                "Leave behind manual processes. Experience the advantages of Pilates class software with a free trial today!"
            ],
            image: "https://cdn.prod.website-files.com/65cf291726560ca345cb8412/67e40b6be78e3d0f305aeb95_PILATES%20FOOTER%20IMAGE.jpg",
            links: [
                "Get Full Access Now!",
                "Book A Demo",
                "Check Pricing"
            ],
        }
    ],

    AdvantageHeadText: "Advantages of Our Pilates Studio Management Software",
    AdvantageDescText: "Our software not only saves time but also increases member satisfaction and helps grow your Pilates studio faster.",

    featuresData: [
        {
            title: "Seamless System Migration",
            description: [
                "Easymembr’s expert team assists in migrating all existing data from other platforms with ease.",
                "Track financial performance with comprehensive reports and trends.",
                "Customize dashboards to display key performance indicators like bookings, income, and retention."],
            icon: "https://fitgymsoftware.com/images/icons/integration.webp"
        },
        {
            title: "Client Relationship Management",
            description: [
                "Maintain detailed client profiles with preferences, attendance, and communications.",
                "Deliver personalized session suggestions and offers for higher engagement.",
                "Keep clients engaged through tips and updates for Pilates and wellness."],
            icon: "https://fitgymsoftware.com/images/icons/engagement.webp"
        },
        {
            title: "Dynamic Class Scheduling",
            description: [
                "Manage both online and in-studio class bookings from a centralized platform.",
                "Auto-adjust schedules for cancellations or changes in real-time.",
                "Optimize class attendance by managing limits and waitlists effectively."],
            icon: "https://fitgymsoftware.com/images/icons/scheduling.webp"
        },
        {
            title: "Marketing & Communication Tools",
            description: [
                "Send targeted promotions and updates via email, SMS, and WhatsApp directly from the dashboard.",
                "Launch referral and loyalty programs to boost client acquisition and retention.",
                "Run seasonal campaigns and promotions effortlessly."],
            icon: "https://fitgymsoftware.com/images/icons/marketing.webp"
        },
        {
            title: "Dedicated Support & Staff Performance Insights",
            description: [
                "Multi-language customer support ensures smooth issue resolution.",
                "Get quick responses from our expert help desk anytime.",
                "Evaluate instructor performance and refine team training based on insights."],
            icon: "https://fitgymsoftware.com/images/icons/support.webp"
        },
    ]
};

export default pilatesData;
